import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Example: get token from localStorage
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/" replace />; // redirect to login
  }

  return children;
};

export default PrivateRoute;
